var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificationAssistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FE8839;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217,109.3H348c4.4-0.1,7.9-3.7,7.8-8.2c-0.1-4.3-3.5-7.8-7.8-7.8H217c-4.4,0.1-7.9,3.7-7.8,8.2 C209.2,105.8,212.7,109.2,217,109.3L217,109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217,154.2h86.6c4.4-0.1,7.9-3.7,7.9-8.1c-0.1-4.3-3.6-7.8-7.9-7.9H217c-4.4,0.1-7.9,3.8-7.8,8.2 C209.3,150.6,212.7,154.1,217,154.2L217,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.1,219.6H103c-4.4,0-8,3.7-7.9,8.1c0,4.4,3.6,7.9,7.9,7.9h74.1c4.4-0.1,7.9-3.7,7.8-8.2 C184.9,223.1,181.4,219.7,177.1,219.6L177.1,219.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103,280.4h49c4.4-0.1,7.9-3.7,7.9-8.1c-0.1-4.3-3.6-7.8-7.9-7.9h-49c-4.4,0.1-7.9,3.7-7.8,8.2 C95.3,276.9,98.7,280.3,103,280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.9,345.8H103c-4.4,0-8,3.6-8,8s3.6,8,8,8h67.8c4.4-0.1,7.9-3.7,7.8-8.2 C178.6,349.4,175.2,345.9,170.9,345.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.9,390.7H103c-4.4,0.1-7.9,3.7-7.9,8.1c0.1,4.3,3.6,7.8,7.9,7.9h44.8c4.4,0,8.1-3.6,8.1-8 C155.9,394.2,152.3,390.6,147.9,390.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.7,167.3c13.2,0,24-10.8,24-24v-18l19.9-13.3c3.6-2.5,4.5-7.5,2-11.1c-2.5-3.5-7.3-4.5-10.9-2.2l-11.1,7.4 c1-13.3-9-24.9-22.3-25.9c-0.5,0-1.1-0.1-1.7-0.1h-39.2c-13.2,0-24,10.8-24,24v39.2c0,13.2,10.8,24,24,24L150.7,167.3z  M103.5,143.3v-39.2c0-4.4,3.6-8,8-8h39.2c4.4,0,8,3.6,8,8v12.7L143.3,127l-10.1-19.2c-2.1-3.9-6.9-5.4-10.8-3.4 c-3.9,2.1-5.4,6.9-3.4,10.8c0,0,0,0,0,0l14.2,27c2.1,3.9,7,5.4,10.9,3.3c0.2-0.1,0.4-0.2,0.6-0.4l13.8-9.2v7.3c0,4.4-3.6,8-8,8 h-39.2C107.1,151.3,103.5,147.8,103.5,143.3L103.5,143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.7,396.4l-40.5-32.5V66c0-22.1-17.9-40-40-40H102.4c-22.1,0-40,17.9-40,40v368c0,22.1,17.9,40,40,40h244.8 c22.1,0,40-17.9,40-40c-0.1-0.2,6.3,5,6.3,5c11.9,9.3,29,7.2,38.3-4.6C441,422.7,439.1,405.8,427.7,396.4z M371.2,434 c0,13.2-10.8,24-24,24H102.4c-13.2,0-24-10.8-24-24V66c0-13.2,10.8-24,24-24h244.8c13.2,0,24,10.8,24,24v285 c-5.1-4.6-13-4.1-17.5,1c-0.1,0.1-0.2,0.3-0.4,0.4l-4.4,5.4l-7.8-6.3c11-16.5,15.8-36.4,13.6-56.1 c-7.4-74.6-104.7-103.1-151.1-44.1c-64.9,86.1,49.8,187.8,127.5,112.7l7.9,6.3l-4.4,5.4c-4.2,5.3-3.4,13.1,1.9,17.3l34.8,27.9 L371.2,434z M338.8,297.3c7.4,60.2-65.3,100.1-112.1,61.4c-29.6-24-34.4-67.4-10.6-97.3C253.2,213.6,333.2,236.9,338.8,297.3z  M419.4,424.8c-3.9,4.9-11,5.6-15.9,1.7L349.3,383l14.2-17.6l54.2,43.5C422.5,412.8,423.3,419.9,419.4,424.8L419.4,424.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificationAssistance);
export default __webpack_public_path__ + "static/media/Certification Assistance.11f5e958089178722923e9d583659a30.svg";
export { ForwardRef as ReactComponent };